import { type CoreProduct, type CoreItem } from '@flecto/types'
import { getImageUrl } from '@flecto/utils'

export type UseItemPhotoProps = { item?: CoreItem | CoreProduct }

export function useItemPhotoUrl({ item }: UseItemPhotoProps) {
  const url = item?.photos?.[0] ? item?.photos?.[0]?.photo_url : null

  return url ? getImageUrl(url) : undefined
}
